import { type IInternalContactLead } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IInternalContactLeadState } from './types';

export const GET_FROM_CONTACT = 'getFromContact';
export const GET_FROM_LEAD = 'getFromLead';
export const GET_FROM_CONTACT_AND_LEAD = 'getFromContactAndLead';

const getInternalContactLead = (_state: IInternalContactLeadState, ids = [] as number[]): IInternalContactLead[] => {
    return ids
        .map((internalContactLeadId: number) => {
            return _state.dataObjectList.get(internalContactLeadId);
        })
        .filter((internalContactLead) => {
            return internalContactLead;
        });
};

export const getters: GetterTree<IInternalContactLeadState, unknown> = {
    [GET_FROM_LEAD]: (_state: IInternalContactLeadState) => {
        return (leadId: number): IInternalContactLead[] | undefined => {
            return getInternalContactLead(_state, _state.byLead.get(leadId) ?? []);
        };
    }
};
